<template>
    <a href="https://www.braingineers.com" target="_blank">
        <div class="footer">
            <img src="@/assets/logo.svg" alt="brain muscles">
            <p style="margin-top: 5px;"><b>braingineers</b></p>
            <p style="font-size: 10pt;"><i>experiments</i></p>
        </div>
    </a>
</template>

<script>
export default {
    name: "Footer",

}
</script>

<style scoped>

.footer {
    margin: 20px 0;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

img {
    height: 35px;
}

p {
    color: #0A0D3D;
}

</style>